import { clamp as o } from "../../utils/utils.js";
const a = [
  {
    name: "px",
    regexp: new RegExp("^[-+]?[0-9]*.?[0-9]+px$")
  },
  {
    name: "%",
    regexp: new RegExp("^[-+]?[0-9]*.?[0-9]+%$")
  },
  {
    name: "px",
    regexp: new RegExp("^[-+]?[0-9]*.?[0-9]+$")
  }
];
function g(e) {
  if (e === "auto")
    return {
      type: e,
      value: 0
    };
  for (let t = 0; t < a.length; t++) {
    const n = a[t];
    if (n.regexp.test(e))
      return {
        type: n.name,
        value: parseFloat(e)
      };
  }
  return {
    type: "",
    value: e
  };
}
function u(e) {
  switch (typeof e) {
    case "number":
      return {
        type: "px",
        value: e
      };
    case "string":
      return g(e);
    default:
      return {
        type: "",
        value: e
      };
  }
}
function w(e, t, n) {
  const i = d(e), r = Math.min(window.innerHeight, n);
  return o(i, t, r);
}
function x(e, t, n) {
  const i = h(e), r = Math.min(window.innerWidth, n);
  return o(i, t, r);
}
function h(e) {
  const t = u(e);
  return t.type === "%" ? window.innerWidth / 100 * t.value : t.value;
}
function d(e) {
  const t = u(e);
  return t.type === "%" ? window.innerHeight / 100 * t.value : t.value;
}
function m({ pivotY: e, pivotX: t, trueModalWidth: n, trueModalHeight: i }) {
  const r = window.innerWidth - n, p = Math.max(0, window.innerHeight - i), c = t * r, s = e * p;
  return {
    left: parseInt(o(c, 0, r), 10),
    top: parseInt(o(s, 0, p), 10)
  };
}
export {
  w as clampValueToWindowOrMaxHeight,
  x as clampValueToWindowOrMaxWidth,
  d as getHeight,
  m as getModalTopLeftPosition,
  h as getWidth,
  u as parseSizeType
};
//# sourceMappingURL=utils.js.map
